<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <Topimage />
    <Designone />

    <Designtwo
      v-for="menulist in menuLists"
      :key="menulist.id"
      :menulist="menulist"
      :ref="`${menulist.id}`"
    />
  </div>
</template>

<script>
import Topimage from "@/components/Topimage.vue";
import Designone from "@/components/designlist/Designone.vue";
import Designtwo from "@/components/designlist/Designtwo.vue";

import { getCategoryListAPI } from "@/api";

// 首页内容区：banner + 最近去过的村子 + 各分类卡片
// 布局（侧边栏、弹窗、回到顶部）由父级 Home.vue 承担
export default {
  // keep-alive 按 name 匹配（Home.vue 里 include="HomeIndex"）
  name: "HomeIndex",

  components: {
    Topimage,
    Designone,
    Designtwo,
  },

  data() {
    return {
      menuLists: [], // 分类数据
    };
  },

  computed: {
    userId() {
      return this.$store.state.userId;
    },
  },

  created() {
    // 分类被新增/删除/改名（含卡片里改分类）后，重新拉取分类列表
    this.$bus.$on("website-category-changed", this.initListFn);
    // 已在首页时点击侧边栏分类，由这里负责滚动
    this.$bus.$on("scroll-to-category", this.scrollToCategory);
  },

  async mounted() {
    await this.initListFn();
  },

  // 被 keep-alive 缓存后，再次进入不再走 mounted（组件没有重建），改由 activated 处理。
  // 首次挂载也会触发 activated，所以从别处带 ?scrollTo= 进来同样能定位。
  activated() {
    // 从用户中心等页面点击侧边栏分类跳回首页时，按 query 定位到目标分类
    const target = this.$route.query.scrollTo;
    if (target) {
      this.scrollToCategory(target);
      // 清掉 query，避免刷新后重复触发滚动
      this.$router.replace({ path: "/home/index" });
    }
  },

  beforeDestroy() {
    this.$bus.$off("website-category-changed", this.initListFn);
    this.$bus.$off("scroll-to-category", this.scrollToCategory);
  },

  methods: {
    // 获取分类列表
    async initListFn() {
      if (!this.userId) return;
      try {
        const res = await getCategoryListAPI(this.userId);
        this.menuLists = res.data.data;
      } catch (error) {
        console.error("获取分类列表失败:", error);
        this.$message.error("获取分类列表失败，请重试");
      }
    },

    // 滚动到指定分类区
    // 分类与卡片数据均为异步加载，区块高度会随后变化，因此在多个时间点重复定位
    scrollToCategory(id, retries = 8) {
      const target = String(id);
      this.$nextTick(() => {
        const instance = (this.$refs[target] || [])[0];
        if (!instance || !instance.scrollTo) {
          // 区块尚未渲染，稍后重试
          if (retries > 0) {
            setTimeout(() => this.scrollToCategory(target, retries - 1), 120);
          }
          return;
        }
        [0, 500, 1200].forEach((delay) => {
          setTimeout(() => {
            const inst = (this.$refs[target] || [])[0];
            if (inst && inst.scrollTo) inst.scrollTo();
          }, delay);
        });
      });
    },
  },
};
</script>
